module.exports = __webpack_public_path__ + "static/img/sign-lavender.4c29d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sign-lavender.jpg
// module id = XaMO
// module chunks = 9